import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ProductDetailAPI from '../api/ProductDetailAPI';
import LocalStorageUtil from '../util/LocalStorageUtil';
import { makeGetAvailableColors } from '../redux/product/selectors/ProductSelector';
import { StockAvailabilityPopup } from '../components/stock-availability/StockAvailabilityPopup';
import { SHOP_NUMBER_STORAGE_KEY } from '../constants/StorageKeysConstants';
import { isOneSizeProduct } from '@as-react/common-utils';
import { useAemConfig } from '@as-react/common-components';
const StockAvailabilityContainer = ({ productId, productCode, productBrand, productTitle, colors, }) => {
    const [currentStoreData, setCurrentStoreData] = useState();
    const [productSizes, setProductSizes] = useState();
    const [allStoresData, setAllStoresData] = useState([]);
    const [selectedSku, setSelectedSku] = useState();
    const { oneSizeProductCode, productImageConfig, defaultRequestParams: { shopId, market, mainWebshop, language, anaLang }, servicesApi, } = useAemConfig();
    const getProductSizes = (colorVariations) => {
        const sizes = new Map();
        colorVariations.forEach((productColor) => {
            if (productColor.sizes) {
                productColor.sizes.forEach((size) => {
                    if (size.active && size.code) {
                        sizes.set(size.code, size);
                    }
                });
            }
        });
        return Array.from(sizes.values()).sort((size, nextSize) => size.order - nextSize.order);
    };
    const parseStoreData = (storeStockData, productColors) => {
        var _a;
        const availability = [];
        (_a = storeStockData.colours) === null || _a === void 0 ? void 0 : _a.forEach((color) => { var _a; return (_a = color.sizes) === null || _a === void 0 ? void 0 : _a.forEach((size) => availability.push(size)); });
        return productColors.map((productColor) => {
            const color = {
                colorId: productColor.colorId,
                colorCode: productColor.colorCode,
                description: productColor.translations.description,
                swatch: productColor.swatch,
            };
            if (productColor.sizes) {
                const sizes = {};
                productColor.sizes.forEach((size) => {
                    if (size.active) {
                        const availabilityBySku = availability.filter((avail) => String(avail.idSku) === String(size.sku))[0];
                        if (availabilityBySku && availabilityBySku.idSize) {
                            sizes[size.code] = availabilityBySku;
                        }
                    }
                });
                color.sizes = sizes;
            }
            return color;
        });
    };
    const fetchProductAvailabilityForCurrentStore = () => __awaiter(void 0, void 0, void 0, function* () {
        const storeNumber = LocalStorageUtil.getJsonItem(SHOP_NUMBER_STORAGE_KEY);
        const storeAvailabilityData = yield ProductDetailAPI.fetchProductAvailabilityForCurrentStore(servicesApi, { shopId, market, mainWebshop, language, anaLang }, productId, { storeNumber });
        if (storeAvailabilityData) {
            setCurrentStoreData(parseStoreData(storeAvailabilityData, colors));
        }
    });
    const fetchProductAvailabilityForAllStores = (skuId) => __awaiter(void 0, void 0, void 0, function* () {
        const sku = String(skuId);
        if (!sku || sku === selectedSku)
            return;
        setSelectedSku(sku);
        const storesAvailabilityData = yield ProductDetailAPI.fetchProductAvailabilityForAllStores(sku, mainWebshop, shopId, market, anaLang, language, servicesApi);
        setAllStoresData(storesAvailabilityData);
    });
    useEffect(() => {
        fetchProductAvailabilityForCurrentStore();
    }, []);
    useEffect(() => {
        setProductSizes(getProductSizes(colors));
    }, [colors]);
    if (!productSizes) {
        return null;
    }
    return (_jsx(StockAvailabilityPopup, { productCode: productCode, productSizes: productSizes, selectedSku: selectedSku, currentStoreData: currentStoreData, allStoresData: allStoresData, isOneSizeProduct: isOneSizeProduct(productSizes, oneSizeProductCode), productImageCdnDomains: productImageConfig.cdnDomains, productBrand: productBrand, productTitle: productTitle, fetchProductAvailabilityForAllStores: fetchProductAvailabilityForAllStores }));
};
const makeMapStateToProps = () => {
    const getColors = makeGetAvailableColors();
    const mapStateToProps = (state) => ({
        colors: getColors(state),
    });
    return mapStateToProps;
};
export default connect(makeMapStateToProps)(StockAvailabilityContainer);
